import { render, staticRenderFns } from "./zfpage.vue?vue&type=template&id=9155e990&scoped=true&lang=pug"
import script from "./zfpage.vue?vue&type=script&lang=js"
export * from "./zfpage.vue?vue&type=script&lang=js"
import style0 from "./zfpage.vue?vue&type=style&index=0&id=9155e990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9155e990",
  null
  
)

export default component.exports